import React from "react";
import { motion } from "framer-motion";
import img2 from "../../../assets/FOTO/IMG_8412.png";
import img from "../../../assets/FOTO/IMG_7282.JPG";
import img4 from "../../../assets/FOTO/IMG_7180.JPG";
import img3 from "../../../assets/FOTO/mix.png";
import { FaCheckCircle } from "react-icons/fa"; // Dla ikon listy

const Ofertahome = () => {
  const services = [
    {
      title: "Treningi EMS",
      description:
        "Nowoczesne treningi EMS pozwalają na maksymalizację efektów w krótkim czasie. Technologia stymulacji mięśniowej to idealny wybór dla osób zapracowanych.",
      image: img,
      benefits: [
        "Efektywne w budowaniu masy mięśniowej w krótkim czasie.",
        "Idealne dla osób z ograniczonym czasem na treningi.",
        "Zmniejsza ryzyko kontuzji dzięki precyzyjnej stymulacji mięśni.",
        "Może być stosowane w rehabilitacji po urazach.",
        "Umożliwia trening całego ciała w zaledwie 20 minut.",
      ],
    },
    {
      title: "Treningi personalne",
      description:
        "Oferujemy treningi personalne dopasowane do Twoich indywidualnych potrzeb i celów. Trener zadba o Twoją technikę, motywację i osiągnięcie wymarzonych rezultatów.",
      image: img4,
      benefits: [
        "Zapewnia indywidualne podejście do każdego klienta.",
        "Pomaga w szybszym osiąganiu celów fitnessowych.",
        "Zwiększa pewność siebie i motywację do ćwiczeń.",
        "Oferuje różnorodność treningów, aby uniknąć rutyny.",
        "Umożliwia monitorowanie postępów i dostosowywanie planu treningowego.",
      ],
    },
    {
      title: "Hybryda",
      description:
        "Hybryda to innowacyjne połączenie treningów personalnych i EMS, które maksymalizuje efekty w krótkim czasie. Dzięki indywidualnemu podejściu trenera oraz nowoczesnej technologii stymulacji mięśniowej, możesz osiągnąć swoje cele fitnessowe szybciej i efektywniej.",
      image: img3,
      benefits: [
        "Zwiększenie efektywności treningu: Połączenie EMS z treningiem personalnym pozwala na intensyfikację wysiłku, co przekłada się na szybsze osiąganie rezultatów",
        "Indywidualne podejście: Trener dostosowuje program do Twoich potrzeb, uwzględniając Twoje cele, poziom zaawansowania oraz preferencje.",
        "Optymalizację czasu: Dzięki EMS możesz uzyskać efekty w krótszym czasie, co jest idealnym rozwiązaniem dla osób z napiętym harmonogramem.",
        "Wsparcie w rehabilitacji: Hybryda to także doskonałe rozwiązanie dla osób wracających do formy po kontuzjach, które chcą bezpiecznie wzmocnić swoje mięśnie.",
        ,
      ],
    },
    {
      title: "Drenaż limfatyczny",
      description:
        "Drenaż limfatyczny wspomaga prawidłowe krążenie limfy, redukuje obrzęki i przyczynia się do oczyszczania organizmu z toksyn. Idealne rozwiązanie dla osób dbających o zdrowie i dobre samopoczucie.",
      image: img2,
      benefits: [
        "Wspomaga proces odchudzania i redukcji cellulitu.",
        "Zwiększa elastyczność skóry i poprawia jej wygląd.",
        "Pomaga w regeneracji po intensywnym wysiłku fizycznym.",
        "Zmniejsza ryzyko wystąpienia żylaków.",
        "Ułatwia usuwanie toksyn i zbędnych produktów przemiany materii.",
      ],
    },
  ];

  return (
    <section className="bg-[#191919] text-white pb-10 ">
      {/* Background z Overlay */}
      <div
        className="relative bg-cover bg-center pt-[150px] pb-[50px]"
        style={{
          backgroundImage: `url(${img2})`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>{" "}
        {/* Ciemna nakładka */}
        <motion.h1
          className="text-5xl font-semibold text-center mb-8 text-white uppercase relative"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          To w czym jesteśmy najlepsi
        </motion.h1>
      </div>

      {/* Sekcje z usługami */}
      <div className="max-w-7xl mx-auto space-y-16 mt-10 px-4">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className={`relative flex flex-col md:flex-row items-center gap-8`}
          >
            {/* Sekcja z obrazem */}
            {index % 2 === 0 ? (
              <>
                <div
                  className={`relative flex-1 transform rotate-2 transition-transform duration-500`}
                >
                  <motion.div
                    className={`relative overflow-hidden rounded-lg shadow-lg translate-y-5`}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  >
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform"
                    />
                    <div
                      className="absolute top-0 left-0 w-full h-full bg-black/30"
                      aria-hidden="true"
                    ></div>
                  </motion.div>
                </div>

                {/* Sekcja z tekstem */}
                <div className="flex-1 text-center md:text-left">
                  <motion.h3
                    className="text-xl md:text-4xl lg:text-6xl font-bold mb-4 text-[#F5EBDC] uppercase"
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                  >
                    {service.title}
                  </motion.h3>
                  <motion.p
                    className="text-[#F5EBDC] mb-4"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                  >
                    {service.description}
                  </motion.p>

                  {/* Lista z ikonami */}
                  <motion.ul
                    className="space-y-3 text-left"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.3 }}
                  >
                    {service.benefits.map((benefit, idx) => (
                      <li
                        key={idx}
                        className="flex items-center text-[#F5EBDC]"
                      >
                        <FaCheckCircle className="text-orange-500 mr-2" />
                        {benefit}
                      </li>
                    ))}
                  </motion.ul>
                </div>
              </>
            ) : (
              <>
                {/* Sekcja z tekstem */}
                <div className="flex-1 text-center md:text-left">
                  <motion.h3
                    className="text-xl md:text-4xl lg:text-6xl font-bold mb-4 text-[#F5EBDC] uppercase"
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                  >
                    {service.title}
                  </motion.h3>
                  <motion.p
                    className="text-[#F5EBDC] mb-4"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                  >
                    {service.description}
                  </motion.p>

                  {/* Lista z ikonami */}
                  <motion.ul
                    className="space-y-3 text-left"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.3 }}
                  >
                    {service.benefits.map((benefit, idx) => (
                      <li
                        key={idx}
                        className="flex items-center text-[#F5EBDC]"
                      >
                        <FaCheckCircle className="text-orange-500 mr-2" />
                        {benefit}
                      </li>
                    ))}
                  </motion.ul>
                </div>

                {/* Sekcja z obrazem */}
                <div
                  className={`relative flex-1 transform -rotate-2 transition-transform duration-500`}
                >
                  <motion.div
                    className={`relative overflow-hidden rounded-lg shadow-lg -translate-y-5`}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  >
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform"
                    />
                    <div
                      className="absolute top-0 left-0 w-full h-full bg-black/30"
                      aria-hidden="true"
                    ></div>
                  </motion.div>
                </div>
              </>
            )}
          </motion.div>
        ))}
      </div>
      <div className="text-center mt-10">
        <motion.a
          href="/pierwsza-wizyta"
          className="inline-block bg-orange-500 text-white py-4 px-5 rounded hover:bg-orange-700 transition duration-300 text-3xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          Zarezerwuj pierwszą wizytę
        </motion.a>
      </div>
    </section>
  );
};

export default Ofertahome;
